import getGraphQlClient from '~graphql/getGraphQlClient';
import { DELETE_QUOTE } from '../queries/quotes';

export const deleteQuote = async (id) => {
  const graphQlClient = await getGraphQlClient();

  return graphQlClient.mutate({
    mutation: DELETE_QUOTE,
    variables: { id },
  });
};
